import ConnectedAPI from './ConnectedAPI';

export default ConnectedAPI;